// useTermsDialogStyles.js
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  outer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    maxWidth: 720,
    margin: '0 auto',
  },
  scrollBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    height: 220,
    overflow: 'auto',
    padding: theme.spacing(2),
  },
  controlsRow: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },
  buttonsRow: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  footer: {
    marginTop: theme.spacing(2.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  paper: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    fontWeight: 600,
  },
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));